/**
 * useDedicatedServerMetrics — Polling 10s des métriques Hetzner live.
 *
 * Enabled uniquement si status === 'active' (cf spec §7.2).
 * Endpoint : GET /api/v1/admin/dedicated-servers/:id/metrics
 *
 * Si l'endpoint admin n'est pas encore livré (dette signalée dans la mission),
 * le hook retourne simplement `data=undefined, isError=true` — les composants
 * consommateurs affichent alors un fallback "Métriques indisponibles".
 *
 * @spec specs/app/admin/dedicated-servers.md §7.2 §6.3
 */

import { useCustom } from '@refinedev/core';
import type { ServerMetrics } from '@/types/dedicatedServer';

interface UseMetricsOptions {
  enabled?: boolean;
  pollingMs?: number;
}

export function useDedicatedServerMetrics(serverId: string, options?: UseMetricsOptions) {
  const enabled = options?.enabled ?? true;
  const pollingMs = options?.pollingMs ?? 10_000;

  return useCustom<{ data: ServerMetrics }>({
    url: `/api/v1/admin/dedicated-servers/${serverId}/metrics`,
    method: 'get',
    queryOptions: {
      enabled,
      refetchInterval: enabled ? pollingMs : false,
      refetchIntervalInBackground: false,
      retry: 1,
    },
  });
}
